export default __webpack_public_path__ + "static/media/_IMG4372-322.911b9a67.jpg";